import { useSalesCounterpartLabel } from 'components/shared/compact-selector/use-toggle-button';

import './style.scss';
import { useAssertedActiveTabId } from 'hooks/use-asserted-active-tab-id';
import { useAppSelector } from 'hooks/useAppSelector';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import FileCard from 'routes/smart-quote/components/file-card';
import { getPrompt } from 'state/workspaces/smart-quote/selectors';
import { useFormatToRelativeTime } from 'utils/date';

type PromptSummaryProps = {
  promptId: string;
};

const PromptSummary = ({ promptId }: PromptSummaryProps) => {
  const [, setRefreshCounter] = useState(0);
  const tabId = useAssertedActiveTabId();
  const prompt = useAppSelector(state => getPrompt(state, tabId, promptId));

  const { createdAt, filename: fileName, selectedOnBehalfClient, pendingFile } = prompt;
  const clientLabel = useSalesCounterpartLabel(selectedOnBehalfClient);
  useEffect(() => {
    const intervalId = setInterval(() => {
      setRefreshCounter(currentValue => currentValue + 1);
    }, 60000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const relativeTimeFromNow = useFormatToRelativeTime(createdAt);

  return (
    <div className="d-flex flex-column align-items-end">
      <div className="chat-message d-flex flex-column p-12px gap-2">
        <p className="px-1">
          {pendingFile ? (
            <FormattedMessage id="smartQuote.workspace.main.promptSummary.pendingFileLabel" />
          ) : (
            <>
              <FormattedMessage id="smartQuote.workspace.main.promptSummary.mainLabel" />
              {clientLabel && (
                <>
                  <FormattedMessage id="smartQuote.workspace.main.promptSummary.clientLabel" />
                  <b>{clientLabel}</b>
                </>
              )}
            </>
          )}
        </p>
        <FileCard fileName={fileName} />
      </div>
      <div className="text-secondary flex-x py-1">
        <span className="fs-6">{relativeTimeFromNow}</span>
      </div>
    </div>
  );
};

export default PromptSummary;
